// src/utils/stripePromise.ts
import { loadStripe } from '@stripe/stripe-js';

// Sustituye esta clave con tu clave pública real desde el dashboard de Stripe
export const stripePromise = loadStripe('pk_live_51RCR25LJJeBgxPTsD9uBRmS9apWGTZiAM4kVqSogXbZP7VioqfoQTbKVsfubxwXmcWVOHdqwnxufyonbbc5MYpBP00Lkr8Rcpx');
